<template>
  <div class="c-integration-workflow">
    <div class="workflow-enabled-setting">
      <div class="mt-8 text-neutral-text-strong">
        <div class="title">
          <FontAwesomeIcon :icon="['fak', 'mapping']" />
          <h3>{{ title }}</h3>
        </div>
        <p class="text-neutral-text text-sm">{{ description }}</p>
      </div>
      <component :is="isIntegrationEnabled ? 'div' : BittsTooltip">
        <BittsSwitch v-model="isEnabled" :disabled="!isIntegrationEnabled" />
        <template #title>
          Enable push data in General Settings for more granular push controls
        </template>
      </component>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { BittsSwitch, BittsTooltip } from '@crossbeam/bitts';

import { inject } from 'vue';

import { ProvidedIsIntegrationEnabled } from '@/injectionKeys/integration_profiles';

const { title, description } = defineProps<{
  title: string;
  description: string;
}>();

const isEnabled = defineModel<boolean>('isEnabled');

const isIntegrationEnabled = inject(ProvidedIsIntegrationEnabled);
</script>

<style scoped lang="pcss">
.c-integration-workflow {
  @apply p-16;
}

.workflow-enabled-setting {
  @apply flex items-center gap-16 mb-12;
}

.title {
  @apply flex items-center text-neutral-text-strong font-bold gap-8 mb-4;
}
</style>
